import { PossibleBillingPeriodTypes } from '@constants/billingPeriods'
import { CurrencyType } from '@constants/currencies'
import { PlanRecordKeyTypes } from '@constants/plans'
import { AxiosError } from 'axios'
import useSWR from 'swr'

interface Option {
  name: string
  key: string
  value: string
}

interface Limit {
  name: string
  key: string
  value: string
}

interface Pricing {
  currency: CurrencyType
  price: number
}

export interface Tariff {
  period: PossibleBillingPeriodTypes
  pricing: Pricing[]
}

export interface GetPackagesTypes {
  id: number
  identifier: string
  name: string
  record_key: PlanRecordKeyTypes
  features: string[]
  options: Option[]
  limits: Limit[]
  tariffs: Tariff[]
}

export const useGetPackages = () =>
  useSWR<GetPackagesTypes[], AxiosError>('packages')
